<template>
  <div>
    <el-row class="systemFont1" style="margin-top: 20px;margin-bottom: 20px;">
      <el-col :span="18" :offset="3">
        <!-- 上课日期时间 -->
        <el-col :span="9"
          >{{ $t("p0416.dateTime") }}：{{
            createTimeFormat(detailList)
          }}</el-col
        >
        <!-- 课程编号 -->
        <el-col :span="6"
          >{{ $t("p0416.courseNumber") }}：{{ detailList.courseNumberView }}</el-col
        >
        <!-- 课程名称 -->
        <el-col :span="9"
          >{{ $t("p0416.courseName") }}：{{ detailList.courseName }}</el-col
        >
      </el-col>
    </el-row>
    <el-table :data="payedUserList" tooltip-effect="dark" style="margin:auto">
      <!-- 介绍人 -->
      <el-table-column
        prop="introduceName"
        :label="$t('p0416.introducer')"
        align="center"
        min-width="80"
      ></el-table-column>
      <!-- 手机号 -->
      <el-table-column
        prop="phoneNo"
        :label="$t('p0416.phone')"
        align="center"
        min-width="85"
      ></el-table-column>
      <!-- 关联公司 -->
      <el-table-column
        prop="company"
        :label="$t('p0416.company')"
        align="left"
        min-width="140"
      ></el-table-column>
      <!-- 优惠码 -->
      <el-table-column
        prop="couponCode"
        :label="$t('p0416.couponCode')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 介绍人数 -->
      <el-table-column
        prop="introduceNum"
        :label="$t('p0416.introduceNum')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 单人佣金 -->
      <el-table-column
        prop="singleCommission"
        :label="$t('p0416.singleCommission')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 佣金总额 -->
      <el-table-column
        prop="totalCommission"
        :label="$t('p0416.totalCommission')"
        align="center"
        min-width="65"
      >
      </el-table-column>
      <!-- 货币 -->
      <el-table-column
        prop="currencyView"
        :label="$t('p0416.currency')"
        align="center"
        min-width="40"
      >
      </el-table-column>
      <!-- 支付时间 -->
      <el-table-column
        prop="commissionPayTime"
        :label="$t('p0416.paymentTime')"
        align="center"
        min-width="100"
        :formatter="createTimeFormat1"
      ></el-table-column>
    </el-table>
    <el-row class="foot-container" style="margin-bottom: 50px;">
      <!-- 返回 -->
      <el-button type="return" @click="returnBack">{{
        $t("common.back")
      }}</el-button>
    </el-row>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  props: {
    detailList: Object
  },
  data() {
    return {
      // 查询参数
      params: {},
      payedUserList: []
    };
  },
  methods: {
    // 初始化数据
    getPayedCommissionList() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/searchPayedCommissionDetail";
      this.$http
        .post(url, qs.stringify(this.params))
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 获取待结算佣金列表
            this.payedUserList = response.data.data;
            console.log(
              "🚀 ~ file: P0420.vue:128 ~ getPayedCommissionList ~ payedUserList",
              this.payedUserList
            );
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 返回上一页
    returnBack() {
      // 调用自定义事件，传入参数
      this.$emit("getViewFlag", true);
    },
    //创建日期格式化时间
    createTimeFormat(row) {
      if (row.dateAndTime != null && row.dateAndTime != "") {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    //创建日期格式化时间1
    createTimeFormat1(row) {
      if (row.commissionPayTime != null && row.commissionPayTime != "") {
        return moment(row.commissionPayTime).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  mounted() {
    this.params = {
      field: this.detailList.courseNumberView.substring(0, 2),
      category: this.detailList.courseNumberView.substring(2, 4),
      courseNumber: this.detailList.courseNumberView.substring(4, 6),
      courseNumberView: this.detailList.courseNumberView,
      dateAndTime: this.detailList.dateAndTime
    };
    this.getPayedCommissionList();
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
.foot-container {
  margin-top: 5%;
  margin-left: 40%;
  width: 20%;
  text-align: center;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
//弹出框屏幕居中
>>> .el-dialog {
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}
//弹出框内容居中
>>> .el-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0420.vue